var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M73.8897903,64.5048127 L87.3404074,41.2466353 L93.8415389,64.5176466 L87.3404074,87.7790325 L73.8897903,64.5176466 L73.8897903,64.5048127 Z M67.3342158,68.2811784 L80.7880354,91.5553981 L57.3583415,85.536314 L40.4329818,68.2811784 L67.3342158,68.2811784 Z M80.7848328,37.4542273 L67.3342158,60.7252386 L40.4329818,60.7252386 L57.3583415,43.4701029 L80.7816303,37.4542273 L80.7848328,37.4542273 Z M100,56.5863161 L91.7823135,26 L61.153337,34.1976332 L56.6185576,42.1835076 L47.417695,42.1161298 L25,64.5048127 L47.417695,86.8902871 L56.6121525,86.8197008 L61.153337,94.8055752 L91.7823135,103 L99.9807848,72.4201008 L95.3275118,64.5016042 L100,56.5863161 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityIcon);
export default __webpack_public_path__ + "static/media/unity-icon.dcb49d061907948125bef8017729ea9d.svg";
export { ForwardRef as ReactComponent };